import { render } from "./PlatformBilling.vue?vue&type=template&id=897f7d62&scoped=true"
import script from "./PlatformBilling.vue?vue&type=script&lang=js"
export * from "./PlatformBilling.vue?vue&type=script&lang=js"

import "./PlatformBilling.vue?vue&type=style&index=0&id=897f7d62&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-897f7d62"]])

export default __exports__